import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum LeadRouteNames {
  LEAD_TABLE = "LEAD_TABLE",
  LEAD_DETAIL = "LEAD_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Lead = { leadId: string };
type Query = { query?: Record<string, string> };

export class LeadGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = LeadGoToHelper.locations;

    return {
      LeadTable: (partnerId: string) => {
        return {
          text: $t("nav.LEAD_TABLE.title").toString(),
          exact: true,
          to: locations.leadTable({ partnerId })
        };
      },
      LeadDetail: (partnerId: string, leadId: string) => {
        return {
          text: $t("nav.LEAD_DETAIL.title").toString(),
          exact: true,
          to: locations.leadDetail({ partnerId, leadId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    leadTable: (d: Partner & Query) => {
      return {
        name: LeadRouteNames.LEAD_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    leadDetail: (d: Partner & Lead & Query) => {
      return {
        name: LeadRouteNames.LEAD_DETAIL,
        params: { partnerId: d.partnerId, leadId: d.leadId },
        query: d.query
      };
    }
  };

  goToLeadTable(d: Tab & Partner) {
    this.go(LeadGoToHelper.locations.leadTable(d), d.newTab);
  }

  goToLeadDetail(d: Tab & Partner & Lead) {
    this.go(LeadGoToHelper.locations.leadDetail(d), d.newTab);
  }
}
